export interface AddressResult {
  zipcode: string;
  postalCode: string;
  prefecture: string;
  city: string;
  town: string;
  address: string;
}

interface ZipCloudResult {
  zipcode: string;
  prefcode: string;
  address1: string;
  address2: string;
  address3: string;
  kana1: string;
  kana2: string;
  kana3: string;
}

interface ZipCloudResponse {
  message: string | null;
  results: ZipCloudResult[] | null;
  status: number;
}

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return '不明なエラー';
}

export function formatPostalCode(zipcode: string): string {
  const normalized = zipcode.replace(/-/g, '');
  if (normalized.length === 7) {
    return `${normalized.slice(0, 3)}-${normalized.slice(3)}`;
  }
  return zipcode;
}

export async function lookupPostalCode(
  zipcode: string
): Promise<AddressResult | null> {
  const normalized = zipcode.replace(/-/g, '');
  if (!/^\d{7}$/.test(normalized)) return null;

  try {
    const url = `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${normalized}`;
    const res = await fetch(url);
    if (!res.ok) return null;

    const json: ZipCloudResponse = (await res.json()) as ZipCloudResponse;
    if (!json.results || json.results.length === 0) return null;

    const r = json.results[0];
    const address = `${r.address1}${r.address2}${r.address3}`;
    return {
      zipcode: normalized,
      postalCode: normalized,
      prefecture: r.address1,
      city: r.address2,
      town: r.address3,
      address,
    };
  } catch (error: unknown) {
    console.warn('郵便番号検索エラー:', getErrorMessage(error));
    return null;
  }
}
